module.exports = __webpack_public_path__ + "img/web.dd9c77fa.png";